module.exports = __webpack_public_path__ + "img/watercare_soob.0448910f.png";